import React from 'react';
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import authAxios from "../../services/Token";
import PDFActasInterventorias from './PDFActasInterventorias';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDoubleLeft, faAngleDoubleRight, faAngleLeft, faAngleRight, faEdit, faFileWord, faFilter, faPlus, faPrint, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { PDFViewer, PDFDownloadLink} from '@react-pdf/renderer';
import WordActasInterventorias from './WordActasInterventorias';

class Listar extends React.Component {
    constructor(props) {
        super(props);
        this.downloadTask = null; // Store the task reference
    }
    state = {
        load: '',
        id_tabla_interventoria: '',
        datosCargados: false,
        urlDocumento: '',
        actasInterventoria: [],
        datosActaInterventoria: [], 
        datosActaInterventoriaWord: [],
        download: false,
        filename: '',
        municipality: ''
    }
    borrarRegistros = (id) => {
        Swal.fire({
            title: 'Está seguro de Eliminar el Acta de Interventoría?',
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: 'Borrar',
            denyButtonText: `Cancelar`,
        }).then((result) => {
            if (result.isConfirmed) {
                let id_usuario = localStorage.getItem('idusuario');
                authAxios.get(`actas_interventoria/borrar/${id}/${id_usuario}`)
                    .then((datosRespuesta) => {
                        console.log(datosRespuesta);
                        Swal.fire('Borrado!', datosRespuesta.data.msj, 'success')
                        this.ListarActasInterventoria(1);
                    })
                    .catch(console.log);
            } else if (result.isDenied) {
                Swal.fire('Cancelado', '', 'info')
            }
        })
    };
    ListarActasInterventoria(page) {
        Swal.showLoading();
        let bname = document.getElementById('bnombre').value;
        let btipo_busqueda = document.getElementById('btipo_busqueda').value;
        if (bname == '') {
            bname = 0;
        }
        if (btipo_busqueda == '') {
            btipo_busqueda = 0;
        }
        authAxios.get("actas_interventoria/index/" + btipo_busqueda + "/" + bname + "?page=" + page)
            .then((datosRespuesta) => {
                //console.log(datosRespuesta);
                Swal.close();
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                this.setState({ datosCargados: true, load: '', actasInterventoria: datosRespuesta.data.data, pagina: datosRespuesta.data.total, ultimo: datosRespuesta.data.last_page, actual: datosRespuesta.data.current_page });
            })
            .catch(console.log);
    }
    previewPDFActasInterventoria = (id_acta) => {
        Swal.showLoading();
        authAxios.get(`actas_interventoria/generar_acta/${id_acta}`)
        .then((response) => {
            Swal.close();
            var status = response.data.status;
            if (status) {
                Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                window.localStorage.clear();
                window.location.href = '/';
            }
            let filename = response.data.resultAll[0].resultActa.PERIODO_ACTA ? `Acta de Interventoria ${response.data.resultAll[0].resultActa.MUNICIPIO} - ${response.data.resultAll[0].resultActa.PERIODO_ACTA}.pdf`: 'Acta de Interventoria.pdf'
            this.setState({ datosActaInterventoria: response.data.resultAll, filename: filename });
        })
        .catch((error) => console.log(error));
    }

    previewWord = (id_acta) => {
        console.log(id_acta);
        authAxios.get(`actas_interventoria/generar_acta/${id_acta}`)
        .then((response) => {
            Swal.close();
            var status = response.data.status;
            if (status) {
                Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                window.localStorage.clear();
                window.location.href = '/';
            }
            this.setState({ datosActaInterventoriaWord: response.data.resultAll, municipality: response.data.resultAll[0].resultActa.MUNICIPIO })
        })
        .catch(error => {
            console.error("Error fetching data:", error);
        });
    }
    componentDidMount() {
        this.ListarActasInterventoria(1);
    }
    render() {
        const { load, actasInterventoria, id_tabla_interventoria, pagina, ultimo, actual, datosActaInterventoria, filename, datosActaInterventoriaWord, municipality } = this.state;
        return (
            <>
                <div className="content">
                    <div className="container-fluid">
                        <br />
                        <div className="card">
                            <div className="card-header">
                                <Link className="btn btn-success btn-sm" to={"/AddActasInterventoria"}><FontAwesomeIcon icon={faPlus} />&nbsp;&nbsp;Nueva Acta</Link>
                            </div>
                            <div className="card-body">
                                <h4>Lista Actas Interventoría</h4>
                                <hr />
                                <div className="row">
                                    <div className="col-xl-2">
                                        <select name="btipo_busqueda" id="btipo_busqueda"
                                            className={"form-select form-select-sm"}
                                            onChange={this.cambioValor}>
                                                <option value="">-</option>
                                                <option value="municipio">MUNICIPIO</option>
                                                <option value="periodo">PERIODO</option>
                                        </select>
                                    </div>
                                    <div className="col-xl-4">
                                        <input style={{ textTransform: 'uppercase' }} type="text" id="bnombre" name="bnombre" placeholder="ACTAS INTERVENTORÍA" className="form-control form-control-sm" />
                                    </div>
                                    <div className="col-xl-3">
                                        <button id="bt" name="bt" className="btn btn-secondary btn-sm" onClick={() => this.ListarActasInterventoria(1)}><FontAwesomeIcon icon={faFilter} />&nbsp;&nbsp;Filtrar</button>
                                    </div>
                                </div>
                                <br></br>
                                <div className="row">
                                    <table className="table table-hover table-condensed table-sm">
                                        <thead className="thead-inverse">
                                            <tr>
                                                <th className="align-middle">DEPARTAMENTO</th>
                                                <th className="align-middle">MUNICIPIO</th>
                                                <th className="align-middle">PERIODO ACTA</th>
                                                <th className="align-middle">OPCIONES</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {load}
                                            {
                                                actasInterventoria.map((itemActasInterventoria) => (
                                                    <tr key={itemActasInterventoria.ID_ACTA_INTERVENTORIA}>
                                                        <td>{itemActasInterventoria.DEPARTAMENTO}</td>
                                                        <td>{itemActasInterventoria.MUNICIPIO}</td>
                                                        <td>{itemActasInterventoria.PERIODO_ACTA}</td>
                                                        <td>
                                                            <div className="btn-group" role="group" aria-label="">
                                                                <Link
                                                                    className="btn btn-primary btn-sm"
                                                                    to={"/UpActasInterventoria/" + itemActasInterventoria.ID_ACTA_INTERVENTORIA}
                                                                >
                                                                    <FontAwesomeIcon icon={faEdit} />
                                                                </Link>&nbsp;&nbsp;
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-danger btn-sm"
                                                                    onClick={() =>
                                                                        this.borrarRegistros(itemActasInterventoria.ID_ACTA_INTERVENTORIA)
                                                                    }
                                                                >
                                                                    <FontAwesomeIcon icon={faTrashAlt} />
                                                                </button>&nbsp;&nbsp;
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-secondary btn-sm"
                                                                    data-bs-toggle='modal'
                                                                    data-bs-target="#PDFActaInterventoriaModal"
                                                                    slot='end'
                                                                    onClick={() =>{
                                                                        this.previewPDFActasInterventoria(itemActasInterventoria.ID_ACTA_INTERVENTORIA)
                                                                        //this.imprimirActa(itemActasInterventoria.ID_ACTA_INTERVENTORIA);
                                                                        //this.setState({ id_tabla_interventoria: itemActasInterventoria.ID_ACTA_INTERVENTORIA })
                                                                    }}
                                                                >
                                                                    <FontAwesomeIcon icon={faPrint} />
                                                                </button>&nbsp;&nbsp;  
                                                                <button
                                                                    style={{ color: '#FFFFFF' }}
                                                                    type="button"
                                                                    className="btn btn-info btn-sm"
                                                                    data-bs-toggle='modal'
                                                                    data-bs-target="#WordActaInterventoriaModal"
                                                                    onClick={() => {this.previewWord(itemActasInterventoria.ID_ACTA_INTERVENTORIA)}}
                                                                >
                                                                    <FontAwesomeIcon style={{ color: '#FFFFFF' }} icon={faFileWord} />
                                                                </button>                                                                                                                                                                                          
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                <nav aria-label="Page navigation example">
                                    <ul className="pagination">
                                        <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarActasInterventoria(1)}><FontAwesomeIcon icon={faAngleDoubleLeft} /></a></li>
                                        <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarActasInterventoria(actual - 1)}><FontAwesomeIcon icon={faAngleLeft} /></a></li>
                                        {(() => {
                                            let p = [];
                                            p.push(<li className="page-item" key={actual}><a className="page-link" href="#" onClick={() => this.BuscarActaInterventoria(actual)}>{actual}</a></li>);
                                            return p;
                                        })()}
                                        <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarActasInterventoria(actual + 1)}><FontAwesomeIcon icon={faAngleRight} /></a></li>
                                        <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarActasInterventoria(ultimo)}><FontAwesomeIcon icon={faAngleDoubleRight} /></a></li>
                                    </ul>
                                </nav>
                            </div>
                            <div className="card-footer text-muted">
                                <b>Pagina</b> <span className="badge bg-primary">{actual}</span> <b>de</b> <span className="badge bg-primary">{ultimo}</span> | <b>Registros</b> <span className="badge bg-success">{pagina}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal fade" id="PDFActaInterventoriaModal" data-bs-backdrop="static" data-bs-keyboard="false" aria-labelledby="ActaInterventoriaoLabel" aria-hidden="true">
                    <div className="modal-dialog modal-xl" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <div className='col-9'>
                                <h4 className="modal-title w-100 text-center" id="ActaInterventoriaLabel">Acta de Interventoría</h4>
                                </div>
                                <div className='col-2'>
                                    <PDFDownloadLink
                                        document={<PDFActasInterventorias data={datosActaInterventoria} />}
                                        fileName={filename}
                                    >
                                        {({ loading }) =>
                                            loading ? "Loading..." : <button className="btn btn-success"> Descargar PDF <FontAwesomeIcon icon={faPrint} /></button>
                                        }
                                    </PDFDownloadLink>
                                </div>
                                <div className='col-1'>
                                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                </div>
                            </div>
                            <div className="modal-body">
                                <div className='row'>
                                    <div className='col-xl-12'>
                                        {/* <PDFActasInterventorias id_tabla_interventoria={id_tabla_interventoria} /> */}
                                        <PDFViewer style={{ width: "100%", height: "90vh" }}>
                                            <PDFActasInterventorias data={ datosActaInterventoria } />
                                        </PDFViewer>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal fade" id="WordActaInterventoriaModal" data-bs-backdrop="static" data-bs-keyboard="false" aria-labelledby="ActaInterventoriaoLabel" aria-hidden="true">
                    <div className="modal-dialog modal-md" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                            <h4 className="modal-title w-100 text-center" id="ActaInterventoriaLabel">Descargar Word Acta de Interventoría</h4>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body">
                                <div className='row'>
                                    <div className='col-xl-12 text-center'>
                                        Descargar acta de {municipality}:   <WordActasInterventorias datos={datosActaInterventoriaWord}  />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default Listar;